import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";

function querystring(name, url = window.location.href) {
    name = name.replace(/[[]]/g, "\\$&");

    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
    const results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * Custom route component for non authenticated users
 * https://serverless-stack.com/chapters/create-a-route-that-redirects.html
 * 
 * @param {*} param0 
 */
export default function UnauthenticatedRoute({ children, ...rest }) {
    const { isAuthenticated, business } = useAppContext();
    const redirect = querystring("redirect");

    return (
        <Route {...rest}>
        <div className="mainContent">
        {
            //If not authenticated or no application found, render children 
            (!isAuthenticated || !business || business.enabled === false) && (
                children
            )
        }
        {
            //Premium users only have access 
            //If authenticated and business is still onboarding, start at profile page
            business && 
            business.subscriptionType !== null 
                && (!business.onboardingCompletionDate) && (
                <Redirect to={redirect === "" || redirect === null ? "/profile" : redirect} />
            )
        }
        {
            //If authenticated and business has completed onboarding, start at home page
            business && 
            business.subscriptionType !== null 
                && (business.onboardingCompletionDate) && (
                <Redirect to={redirect === "" || redirect === null ? "/profile" : redirect} />
            )
        }
        </div>
        </Route>
    );
}